export default __webpack_public_path__ + "01e1de5df9262435e7cde86abd1a421f.svg";